<template>
<v-card
    style="margin-bottom: 15px;"
>
   <v-card-title>
       
       {{contact_request.customer_name}}

   </v-card-title>

    <v-menu 
        bottom 
        offset-y
        v-if="open"
    >
        
        <template v-slot:activator="{ on }">
            <v-icon 
                size="25"
                v-on="on"
                style="position: absolute; top: 20px; right: 20px;"
            >
                mdi-dots-vertical
            </v-icon>
        </template>

        <v-list>

            <div
                v-if="userSameOrganizationAsContactRequest()"
            >
              <v-list-item
                  v-on:click="sendEmptyReply(true)"
              >
                  <v-list-item-title>Close this contact request</v-list-item-title>
              </v-list-item>

              <v-divider/>
            </div>

            <div
                v-if="$rc.$state.isCommerce7Enabled()"
            >
              <v-list-item
                  v-on:click="onClickCreateCommerce7Customer"
              >
                  <v-list-item-title>Create a customer in Commerce7...</v-list-item-title>
              </v-list-item>

              <v-divider/>
            </div>

            <v-list-item
                v-on:click="assign(true)"
                v-if="created_by_team_member"
            >
                <v-list-item-title>Assign back to {{contact_request.created_by.full_name}}</v-list-item-title>
            </v-list-item>

            <v-list-item
                v-on:click="assign(false)"
            >
                <v-list-item-title>Assign...</v-list-item-title>
            </v-list-item>

             <v-list-item
                v-on:click="onClickMarkAsSpam"
            >
                <v-list-item-title>Block as spam...</v-list-item-title>
            </v-list-item>

            <v-list-item
                v-on:click="onClickShowHeaders"
                v-if="$rc.$state.isSystemsAdmin()"
            >
                <v-list-item-title>Show IP and Headers</v-list-item-title>
            </v-list-item>
            
        </v-list>
    </v-menu>

    <div
        v-if="!open"
        style="position: absolute; top: 20px; right: 20px;"
    >
        <v-icon
            color="green"
            size="35"
        >
            mdi-check-bold
        </v-icon>
    </div>

   <v-card-text>


    <div
        v-if="customer_endpoint_in_crms"
        style="margin-top: -35px; margin-left: -10px;"
    >
        <v-chip
            v-for="(item, key) in customer_endpoint_in_crms"
            :key="key"
            v-on:click="onClickOpenInCRM(item)"
            color="primary"
            class="ma-2"
            label
            small
        >
            {{$rc.pretty(item,'integration_name')}}
            <v-icon right size="15">
                mdi-open-in-new
            </v-icon>
        </v-chip>
    </div>

    <p>
        <v-row>
        <v-col>
            <span class="heading">Phone Number</span><br/>
            {{pretty_phone_number}}
        </v-col>
        <v-col
            v-if="has_phone_validation_result"
            align="right"
        >
            <div
                style="height: 12px;"
            >
            </div>
            <m-phone-validation-chip
                :value="{ 'orig_result' : validations.phone}"
            />
        </v-col>
        </v-row>
    </p>

     <p
        v-if="has_ip_validation_result"
    >
        <span class="heading">IP Address</span><br/>
        {{validations.ip.ip}} &mdash; {{validations.ip.isp}}<br/>
        {{validations.ip.location}}
    </p>

    <p v-if="message_other_conversations != null">
        <span class="heading">Other Conversations</span><br/>
        {{message_other_conversations}} 
        <a v-on:click="onClickViewOtherConversations">view</a>
    </p>
      
     <m-other-conversations-more-dialog
        ref="other-conversation-dialog"
    />

    <p>
        <span class="heading">Created</span><br/>
        {{pretty_creation_time}}
    </p>

    <p
        v-if="created_by_team_member"
    >
        <span class="heading">Created By</span><br/>
        {{contact_request.created_by.full_name}} ({{contact_request.created_by.username}})
    </p>

    <p
        v-if="!created_by_team_member"
    >
        <span class="heading">Created By</span><br/>
        {{contact_request.customer_name}} (Customer created the contact request)
    </p>

    <!-- Belt and a pair of suspenders -->
    <p
        v-if="hasText(contact_request.inbox_help_with)"
    >
        <span class="heading">Help With</span><br/>
        {{contact_request.inbox_help_with}}
    </p>

    <!-- Belt and a pair of suspenders -->
    <p
        v-if="hasText(contact_request.help_with)"
    >
        <span class="heading">Help With</span><br/>
        {{contact_request.help_with}}
    </p>

    <p
       v-else-if="inbox_summary != null && hasText(inbox_summary.help_with)"
    >
     <span class="heading">Help With</span><br/>
     {{inbox_summary.help_with}}
    </p>

     <p
        v-if="hasText(contact_request.message)"
    >
        <span class="heading">Message</span><br/>
        {{contact_request.message}}
    </p>


    <p
        v-for="(extra_field, ex_index) in contact_request.extra_fields"
        :key="ex_index"
    >
        <b>{{extra_field.text}}</b><br/>
        {{extra_field.value}}
    </p>

    <p 
        v-if="hasText(contact_request.submitted_from_url)"
    >
        <b>Submitted From</b><br/>
        <a v-bind:href='contact_request.submitted_from_url' target="_blank">{{contact_request.submitted_from_url}}</a>
    </p>

    <p
        v-if="contact_request.blob_meta_data != null && contact_request.blob_meta_data.length > 0"
    >
        <span class="heading">Attachment(s)</span><br/>
        <a
            v-for="(blob, bindex) in contact_request.blob_meta_data"
            :key="bindex"
            :href="getBlobHref(blob)"
            target="_blank"
            style="margin-right: 15px"
        >
            {{blob.label}}
        </a>
    </p>

    <p
        v-if="show_ip_and_headers"
    >
        <span class="heading">Submitted From IP</span><br/>
        {{contact_request.submitted_from_ip}} 
    </p>

     <p
        v-if="show_ip_and_headers"
    >
        <span class="heading">HTTP Headers</span><br/>
        {{contact_request.submitted_http_headers}} 
    </p>


    <p
        v-if="!open && contact_request.contacted_by.label"
    >
        <span class="heading">Contacted By</span><br/>
        {{contact_request.contacted_by.label}} ({{contact_request.contacted_by.username}})
    </p>

    <p
        v-if="!open"
    >
        <span class="heading">Contact Time</span><br/>
        {{pretty_contact_time}}
    </p>

    <p
      v-if="!open"
    >
      <span class="heading">Link to Conversation</span><br/>
      <a v-on:click="onClickViewConversation">Click Here</a>
    </p>


     <div
        v-if="open"
        v-show="reply_controls_visible"
    >
        <v-select
            label="Reply From"
            :items=employee_endpoints
            v-model="active_endpoint"
            return-object
        />

         <v-textarea
            label="Reply With"
            value=""
            ref="reply_with"
            v-model="reply_with"
            v-on:input="onMessageBoxInput"
            @keydown.enter="$event.preventDefault(); sendReply();"
            autofocus
            auto-grow
            rows="1"
         >
            <span
                slot="append-outer"
            >
                <v-icon
                    style="align-self: flex-end; margin-bottom: 3px; margin-right: 2px"
                    v-on:click="toggleEmojiSelector"
                >
                    mdi-emoticon-outline
                </v-icon>
            </span>

            <span
                slot="append-outer"
            >
                <v-icon
                    v-on:click="showReplyWithInfo"
                >
                    mdi-information-outline
                </v-icon>
            </span>
        </v-textarea>

         <v-chip
            color="primary"
            class="ma-2"
            label
            small
            v-if="reply_with != null && reply_with.length > 0"
            style="position: relative; top: -15px; left: -5px"
        >
            {{reply_with_message_type}}
        </v-chip>

        <m-edit-blobs
            v-model="reply_with_blob_ids"
            :process_media="true"
            :externally_visible="true"
        />

    </div>

    

    <div
        v-if="open && userSameOrganizationAsContactRequest()"
        style="text-align: right"
    >
        <v-btn
            v-on:click="sendEmptyReply(true)"
            v-show="!reply_controls_visible"
            style="margin-right: 15px"
        >
            Close Contact Request
        </v-btn>

        <v-btn
            color="primary"
            v-on:click="showReplyControls"
            v-show="!reply_controls_visible"
        >
            Reply
        </v-btn>


        <v-btn
            v-on:click="hideReplyControls"
            v-show="reply_controls_visible"
            style="margin-left: 15px; margin-bottom: 15px;"
        >
            Cancel
        </v-btn>

        <v-btn
            v-on:click="sendEmptyReply"
            v-show="reply_controls_visible"
            style="margin-left: 15px; margin-bottom: 15px;"
            :disabled="active_endpoint == null"
        >
            Reply without a message
        </v-btn>

        <v-btn
            color="primary"
            v-on:click="sendReply"
            v-show="reply_controls_visible"
            style="margin-left: 15px; margin-bottom: 15px;"
            :disabled="active_endpoint == null"
        >
            Send
        </v-btn>

        <div
            v-if="reply_controls_visible && open_ai_completions != null && open_ai_completions.length > 0"
            style="text-align: left"
        >
            <div
                style="margin-top: 20px; margin-bottom: 15px; font-size: 20px;"
            >
                <b>AI Suggested Responses</b>
            </div>

            
            <div
                v-for="(item, index) in open_ai_completions"
                :key="'open_ai_comp_'+index"
                style="border: 1px solid rgba(0,0,0,0.1); border-radius: 7px; padding: 15px; margin-bottom: 15px;"
            >
                {{item}}

                <div
                    style="text-align: right; margin-top: 15px;"
                >
                    <v-btn
                        v-on:click="onClickAIEditAndSend(item)"
                    >
                        Edit and send...
                    </v-btn>
                </div>
            </div>

            <m-ai-contact-request-suggested-reply-dialog
                ref="ai-contact-request-suggested-reply-dialog"
                v-on:send="onSendAIResponse"
            />
            
        </div>

    </div>

   </v-card-text>

   <m-contact-request-info-dialog
        ref="reply_with_info_dialog"
    />

    <m-contact-request-commerce7-manual-edit-dialog
        ref="contact-request-commerce7-manual-edit-dialog"
        v-on:ok="doCreateCommerce7Customer"
    />

    <m-contact-request-force-assign-dialog
        ref="force_assign_dialog"
        v-on:force-assign="doForceAssignContactRequest($event)"
    />

    <m-search-saved-messages-dialog
        ref="search-saved-messages-dialog"
        v-on:send-and-edit="onSelectSavedMessage"
        :include_send="false"
    />

    

    <m-contact-request-is-typing
        ref="contact-request-is-typing"
        v-if="contact_request != null"
        :organization_id="contact_request.organization_id"
        :contact_request_id="contact_request.contact_request_id"
    />

</v-card>
</template>

<script>
const E164 = require('@/js/E164.js');
const BlobMetaData = require('@/js/BlobMetaData.js');

export default {
    props: {

        contact_request: {
            type: Object,
            default: function() { return {}; }
        },

        inbox_summary: null,
    },

    data() {
        return {
            reply_controls_visible: false,
            active_endpoint: null,
            reply_with: '',
            reply_with_blob_ids: [],
            show_ip_and_headers: false,
            message_other_conversations: null,
            other_conversations: [],
            validations: null,
            employee_endpoints: [],
            open_ai_completions: [],
        }
    },

    mounted () {
        this.updateOtherConversations();

        this.$rc.getContactRequestValidation(
            this.contact_request.contact_request_id,
        
            (data) => {
                this.validations = data;
            },
        
            () => {
                
            },
        );
    },

    methods: {

        toggleEmojiSelector()
        {
            this.$rc.simplePickEmoji(
                (value) => {
                    if ( this.reply_with == null || this.reply_with.trim().length == 0 ) { this.reply_with = value; return; }
                    this.reply_with += ' '+value;
                }
            );

        },

        onSelectSavedMessage(saved_message)
        {
            this.$rc.instantiateSavedMessageFromContactRequest(
                saved_message.saved_message_id,
                this.contact_request.contact_request_id,
                (data) => {
                    this.reply_with = data.result;
                },
                () => {
                    this.$rc.alert(
                        'Error Retrieving Saved Message',
                        'There was an error retrieving the saved message. Please try again.',
                    );
                },
            );
        },

        onMessageBoxInput()
        {
            // only launch the saved message search if the only text is a single hashtag (otherwise, we don't
            // want to launch the search in the middle of their message)
            if ( this.reply_with != null &&  this.reply_with == '#' )
            {
                this.$refs['search-saved-messages-dialog'].showDialog(this.contact_request.organization_id);
            }

            this.$refs['contact-request-is-typing'].updateIsTyping(
                this.$rc.$state.profile.employee_contact,
                true,
            );
        },

        hasText(value)
        {
            if ( value == null ) return false;
            if ( value.trim().length == 0 ) return false;
            return true;
        },

        getBlobHref(blob)
        {
            return this.$rc.getBlobEndpoint(new BlobMetaData(blob));
        },

        showReplyControls()
        {
            this.updateEndpoints();
            this.updateOpenAICompletions();

            if ( this.active_endpoint == null )
                this.active_endpoint = this.getDefaultActiveEndpoint();

            if ( !this.hasText(this.reply_with) )
            {
                this.reply_with = '';
                this.reply_with_blob_ids = [];
            }

            this.reply_controls_visible = true;
        },

        updateOpenAICompletions()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/open-ai/completions/contact-request/:contact_request_id',
            
                'params' : {
                        'contact_request_id': this.contact_request.contact_request_id,
                    },
            
                'on_success': (data) => {
                        this.open_ai_completions = data.results;
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        updateEndpoints()
        {
            if ( this.employee_endpoints.length > 0 )
                return; // no need to update endpoints...

            this.$rc.showSpinner();
                
            this.$rc.rest(
                'LIST: /api/v1/organizations/profile/employee-following-endpoints',
            
                {
                    'organization_id': this.contact_request.organization_id,
                    'employee_id': this.$rc.$state.employee_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    let raw_endpoints = data.results;

                    let ret = [];

                    for ( let i = 0; i < raw_endpoints.length; i++ )
                    {
                        let cur_obj = {
                            'text' : raw_endpoints[i].label+' - '+E164.prettyPrintUsPhoneNumber(raw_endpoints[i].endpoint),
                            'endpoint' : raw_endpoints[i].endpoint,
                            'is_home_endpoint' : raw_endpoints[i].is_home_endpoint == true,
                        };

                        ret.push(cur_obj);

                        if ( raw_endpoints[i].is_home_endpoint == true && this.active_endpoint == null )
                        {
                            this.active_endpoint = cur_obj;
                        }
                    }

                    this.employee_endpoints = ret;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        getDefaultActiveEndpoint()
        {
            let endpoints = this.employee_endpoints;

            if ( endpoints == null || endpoints.length == 0 ) return null;

            for ( let i = 0; i < endpoints.length; i++ )
            {
                if ( endpoints[i].is_home_endpoint == true )
                    return endpoints[i];
            }

            return endpoints[0];
        },

        hideReplyControls()
        {
            this.reply_controls_visible = false;
        },

        showReplyWithInfo()
        {
            this.$refs['reply_with_info_dialog'].showDialog();
        },

        userSameOrganizationAsContactRequest()
        {
          return this.contact_request.organization_id == this.$rc.$state.profile.organization_account.organization_id;
        },

        sendEmptyReply(confirm)
        {
            if ( confirm == true )
            {
                this.$rc.confirm({
                    'title': 'Close this contact request',
                    'body': 'Are you sure that you want to close this contact request without sending a message?',
                    'btn_text_ok': 'Yes',
                    'btn_text_cancel': 'No',
                    'on_ok': () => {
                        this.sendEmptyReply(false);
                        return;
                    },
                });

                return;
            }


            if ( this.active_endpoint == null )
                this.active_endpoint = this.getDefaultActiveEndpoint();

            this.reply_with = '';
            this.reply_with_blob_ids = [];
            this.sendReply();
        },

        onClickCreateCommerce7Customer()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/integrations/crm/before-create-commerce7-customer',
            
                'params' : {
                        'contact_request_id': this.contact_request.contact_request_id,
                    },
            
                'on_success': (data) => {
                        this.$refs['contact-request-commerce7-manual-edit-dialog'].showDialog(data);
                        return;
                    },
            
                'on_error': 'Unable to create commerce7 customer',
            });
        },

        doCreateCommerce7Customer(commerce7_customer_profile)
        {
            this.$rc.rest({
            'spinner': true,
            'endpoint': 'PUT: /api/v1/integrations/crm/create-commerce7-customer-from-contact-request',
           
            'params' : {
                'contact_request_id': this.contact_request.contact_request_id,
                ...commerce7_customer_profile
            },
           
            'on_success': (data) => {
                    if ( data.success )
                    {
                        if ( data.url != null )
                        {
                            window.open(data.url,"_blank");
                        }

                        this.$rc.snackbar("Customer created in commerce7");
                    }
                    else
                    {
                        this.$rc.snackbar(data.message);
                    }
                },
           
            'on_error': 'Unable to create customer in Commerce7',
           });
        },

        onSendAIResponse(text)
        {
            this.reply_with = text;
            this.sendReply();
        },

        sendReply()
        {
            this.$rc.showSpinner();

            let reply_with = this.reply_with;

            let reply_from = null;

            if ( this.active_endpoint != null )
            {
                reply_from = this.active_endpoint.endpoint;
            }
            
            this.$rc.rest(
                'PUT: /api/v1/contact-requests/complete-contact-request',
            
                {
                    'contact_request_id' : this.contact_request.contact_request_id,
                    'reply_from' : reply_from,
                    'reply_with' : reply_with,
                    'blob_ids' : this.reply_with_blob_ids,
                    'submitted_from_url' : this.contact_request.submitted_from_url,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$emit('search');


                    if ( data.reply_sent == false )
                    {
                        if ( this.reply_with == '' ) return; // the intent was to send to message (just mark as replied)
                        this.$rc.alert('Another RedChirp user responded', 'Your reply has not been sent.  Another RedChirp user responded to this customer before you could.');
                        return;
                    }

                    this.reply_with = null;
                    this.reply_controls_visible = false;

                    this.$rc.toHomeForEndpoint(this.$router, this.active_endpoint.endpoint, false, data.conversation_summary.conversation_id);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to reply to contact request.');
                },
            );
        },

        assign(auto_assign)
        {
            if ( this.created_by_team_member == false )
            {
                this.$rc.confirm(
                    'Assign Contact Request',
                    'Assigning a contact request created by a customer will disrupt the notification plan setup for this Inbox. Confirm to proceed, Cancel to go back.',
                    [
                        {'text' : 'Cancel', 'value' : 'cancel' },
                        {'text' : 'Confirm', 'value' : 'confirm' },
                    ],

                    (response) => {
                        if ( response != 'confirm' ) return;
                        this.$refs['force_assign_dialog'].showDialog(this.contact_request);
                    }
                );
            }
            else
            {
                this.$refs['force_assign_dialog'].showDialog(this.contact_request);
            }
        },

        doForceAssignContactRequest(assign_info)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/contact-requests/force-assign',
            
                'params' : {
                        'contact_request_id': this.contact_request.contact_request_id,
                        'additional_message': assign_info.additional_message,
                        'assign_to_employee_ids': assign_info.assign_to_employee_ids,
                    },
            
                'on_success': (data) => {
                        this.$rc.snackbar('Contact request has been assigned.',3500);
                    },
            
                'on_error': 'Unable to assign contact request',
            });
        },

        onClickShowHeaders()
        {
            this.show_ip_and_headers = !this.show_ip_and_headers;
        },

        onClickMarkAsSpam(contact_request)
        {
             this.$rc.confirm(
                'Confirm Spam',
                'Marking this contact request as spam will delete the request.  All future requests that use this phone number will also be marked as spam.',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'It\'s Spam', 'value' : 'confirmed' },
                ],

                (response) => {
                    if ( response != 'confirmed' ) return;
                    
                    this.$rc.showSpinner();
                    
                    this.$rc.markContactRequestAsSpam(
                        this.contact_request.contact_request_id,
                    
                        (data) => {
                            this.$rc.hideSpinner();
                            this.$rc.snackbar('Contact request marked as spam');
                        },
                    
                        () => {
                            this.$rc.hideSpinner();
                            this.$rc.alert('Error','Unable to complete API call');
                        },
                    );
                }
            );
        },

        updateOtherConversations()
        {
            let endpoint = this.contact_request.customer_endpoint;
            let organization_id = this.contact_request.organization_id;
            
            this.$rc.getOtherConversationsByEndpoint(
                organization_id,
                endpoint,
            
                (data) => {
                    this.other_conversations = data.results;
                    this.message_other_conversations = data.most_recent_message;
                },
            
                () => {
                     this.other_conversations = null;
                    this.message_other_conversations = [];
                },
            );
        },

        onClickViewOtherConversations()
        {
            let title = 'Other Conversations';
            let other_conversations = this.other_conversations;
            this.$refs['other-conversation-dialog'].showDialog(title, other_conversations);
        },

        onClickViewConversation()
        {
            let contact_request_id = this.contact_request.contact_request_id;

            this.$rc.showSpinner();

            this.$rc.getContactRequestConversationLink(
                contact_request_id,

                (data) => {
                    this.$rc.hideSpinner();

                    let conversation_link = data.conversation_link;

                    if ( conversation_link == null )
                    {
                        this.$rc.alert('Error','Unable to find conversation');
                        return;
                    }

                    this.$router.push({
                        'name': 'home-routed',
                        'params' : conversation_link,
                    })
                        .catch(e=>{});
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to find conversation');
                },
            );
        },

        onClickOpenInCRM(crm_name)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/integrations/crm/customers/from-endpoint',
            
                {
                    'content_type' : crm_name,
                    'organization_id' : this.contact_request.organization_id,
                    'endpoint' : this.contact_request.customer_endpoint
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    let results = data.results;
                    if ( results.length == 0 )
                    {
                        this.$rc.alert('Error','No customer for this contact exists in '+crm_name);
                        return;
                    }

                    window.open(results[0].url_view_customer_in_crm);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to search '+crm_name+' customers');
                },
            );
        },

        onClickAIEditAndSend(text)
        {
            this.$refs['ai-contact-request-suggested-reply-dialog'].showDialog(this.contact_request.message, text);
        },
    },

    computed: {
        pretty_creation_time()
        {
            return ''+new Date(this.contact_request.creation_time);
        },

        pretty_phone_number()
        {
            return E164.prettyPrintUsPhoneNumber(this.contact_request.customer_endpoint);
        },

        pretty_contact_time()
        {
            return ''+new Date(this.contact_request.contacted_by.contact_time);
        },

        created_by_team_member()
        {
            return this.contact_request.created_by != null;
        },


        open()
        {
            return this.contact_request.contacted_by == null;
        },

        has_phone_validation_result() {
            if ( this.validations == null || this.validations.phone == null ) 
                return false;
            
            return true;
        },

        has_ip_validation_result() {
            if ( this.validations == null || this.validations.ip == null ) 
                return false;
            
            return true;
        },

        reply_with_message_type() {
            return this.$rc.messageType(this.reply_with);
        },

        customer_endpoint_in_crms() {
            if ( this.validations != null && this.validations.customer_endpoint_in_crms != null )
                return this.validations.customer_endpoint_in_crms;

            return this.contact_request.customer_endpoint_in_crms;
        },
    },
}
</script>

<style lang="scss" scoped>
.heading {
    font-weight: bold;
}
</style>